import { useState } from 'react'

import { Minus, Plus } from '../../Components/Icons'
import { usePolicyholderDetailsStore } from '../../Stores/policyholderDetailsStore'
import { CONTEXT_DOCUMENT } from '../../constants/contextDocument'
import { t } from '../../i18n'
import {
  ActionsCell,
  ActionsHeader,
  ButtonContainer,
  Cell,
  Header,
  IdCell,
  IdHeader,
  Row,
  Table,
  TableContainer,
  Title,
} from '../AnimalInsuranceTable/styles'
import { ToggleTableAttachment } from '../QuoteRequestStatus/Contents/ToggleTableAttachment'
import { TabPageContainer } from '../QuoteRequestStatus/styles'

export const ManualSignaturesSelection = () => {
  const { policyholderDetailsSelected } = usePolicyholderDetailsStore()
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <Title>{t('pages.step7.uploadDocuments')}</Title>
      <TableContainer>
        <Table>
          <thead>
            <Row>
              <IdHeader></IdHeader>
              <Header>{t('table.name')}</Header>
              <Header>{t('table.vatNumber')}</Header>
              <ActionsHeader></ActionsHeader>
            </Row>
          </thead>
          <tbody>
            <Row>
              <IdCell />
              <Cell>
                <div className="owner-data">{t('pages.step7.owner')}</div>
                <label className="label">
                  {policyholderDetailsSelected?.name}
                </label>
              </Cell>
              <Cell>
                <label className="label">
                  {policyholderDetailsSelected?.vatNumber}
                </label>
              </Cell>
              <ActionsCell>
                <ButtonContainer onClick={() => setExpanded((prev) => !prev)}>
                  {expanded ? (
                    <Plus color="#333" size={24} />
                  ) : (
                    <Minus color="#333" size={24} />
                  )}
                </ButtonContainer>
              </ActionsCell>
            </Row>
            <Row hidden={expanded}>
              <Cell colSpan={4} visible>
                <div className="container">
                  <TabPageContainer>
                    <ToggleTableAttachment
                      context={CONTEXT_DOCUMENT.CONFIRMATION_UPLOAD}
                    />
                  </TabPageContainer>
                </div>
              </Cell>
            </Row>
          </tbody>
        </Table>
      </TableContainer>
    </>
  )
}
